const WholesaleForm = () => {
  const wholesaleForm = document.querySelector(".wholesale__form");

  if (wholesaleForm) {
    const shippingAdressRadioGroup = wholesaleForm.querySelectorAll("input[name='shipping-adress']");
    const shippingAdressFields = wholesaleForm.querySelector("#shipping-address-fields");

    const businessInfoRadioGroup = wholesaleForm.querySelectorAll("input[name='business-info']");
    const usBusinessFields = wholesaleForm.querySelector("#us-business-fields");
    const euBusinessFields = wholesaleForm.querySelector("#eu-business-fields");
    const intBusinessFields = wholesaleForm.querySelector("#asia-business-fields");
    
    const handleRadioChangeShippingAdress = () => {
      if (shippingAdressRadioGroup[1].checked) {
        shippingAdressFields.classList.remove("d-none");
      } else {
        shippingAdressFields.classList.add("d-none");
      }
    };

    shippingAdressRadioGroup.forEach((radio) => {
      radio.addEventListener("change", handleRadioChangeShippingAdress);
    });

    handleRadioChangeShippingAdress();

    const handleRadioChangeBusinessInfo = () => {
      usBusinessFields.classList.add("d-none");
      euBusinessFields.classList.add("d-none");
      intBusinessFields.classList.add("d-none");

      if (businessInfoRadioGroup[0].checked) {
        usBusinessFields.classList.remove("d-none");
      } else if (businessInfoRadioGroup[1].checked) {
        euBusinessFields.classList.remove("d-none");
      } else if (businessInfoRadioGroup[2].checked) {
        intBusinessFields.classList.remove("d-none");
      }
    };

    businessInfoRadioGroup.forEach((radio) => {
      radio.addEventListener("change", handleRadioChangeBusinessInfo);
    });

    handleRadioChangeBusinessInfo();
  }
}

export default WholesaleForm;
